import React, { useState, useEffect,useCallback } from 'react';
import ProfilePicture from './ProfilePicture';
import PersonalInfo from './PersonalInfo';
import { motion } from 'framer-motion';
import PermissionMenus from './PermissionMenus';
import DepotController from '../../controllers/depot-controller';
import { fetchAllProducts } from '../../controllers/products-controller';



const AddUser = ({ formId, onSubmit, isSubmitting, initialData = null }) => {

  // Animation variants
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } }
  };

  const tabVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3, delay: 0.2 } }
  };
  const [formData, setFormData] = useState({
    firstName: '',
    lastName:'',
    email: '',
    phoneNumber: '',
    dateOfBirth:'',
    userName: '',
    codeUser: '',
   // type:'',
    passwordHash:'',
    plateformId:'',
    depotId: '',
    productIds: [],
    active:false,
    image:null,
    permission:[]
  });
  const [activeTab, setActiveTab] = useState('personal');
  const [depots, setDepots] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [productSearch, setProductSearch] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const ds = await DepotController.getAllDepots();
        setDepots(ds || []);
      } catch (e) { console.error(e); }
      try {
        const ps = await fetchAllProducts();
        setAllProducts(ps || []);
      } catch (e) { console.error(e); }
    })();
  }, []);


 const [errors, setErrors] = useState({});


  // Use initialData if provided (for editing existing suppliers)
  useEffect(() => {
    if (initialData) {

      setFormData({
        email: initialData.email || '',
        firstName: initialData.firstName|| '',
        lastName:initialData.lastName|| '',
        email: initialData.email|| '',
        phoneNumber: initialData.phoneNumber|| '',
        dateOfBirth:initialData.dateOfBirth|| '',
        userName: initialData.userName|| '',
        codeUser: initialData.codeUser|| '',
        passwordHash:initialData.passwordHash|| '',
        plateformId:initialData.plateformId?.toString()|| '',
        depotId: initialData.depotId ? initialData.depotId.toString() : '',
        productIds: initialData.productIds || [],
        active:initialData.active,
        image:initialData.imagePath|| '',
        permission:initialData.permissions

      });
    }
  }, [initialData]);

  const validateForm = () => {
    const newErrors = {};
    // Only require username and password. Other fields are optional.
    if (!formData.userName?.trim()) {
      newErrors.userName = 'Le Nom d\'utilisateur est requis';
    }

    if (!formData.passwordHash || !formData.passwordHash.trim()) {
      newErrors.passwordHash = 'Le mot de passe est requis';
    } else if (formData.passwordHash.length < 6) {
      newErrors.passwordHash = 'Le mot de passe doit contenir au moins 6 caractères';
    }

    // If email is provided, validate its format
    if (formData.email?.trim() && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'L\'email est invalide';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleChange = useCallback((e) => {    const { name, value,checked  } = e.target;

  // Detect permission pattern like "produit__write"
  if (name.includes('__')) {
    const [menu, action] = name.split('__');
    const permissionKey = `Menu_${menu}_${action}`;

    setFormData((prev) => {
      const currentPermissions = prev.permission || [];
      const hasPermission = currentPermissions.includes(permissionKey);

      return {
        ...prev,
        permission: checked
          ? [...currentPermissions, permissionKey]
          : currentPermissions.filter((perm) => perm !== permissionKey),
      };
    });

    return;
  }

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <form id={formId} onSubmit={handleSubmit} className="flex flex-col h-[75vh] md:h-[70dvh] min-h-0" encType="multipart/form-data">
                    <div className="bg-white shadow sm:rounded-lg flex flex-col flex-1 min-h-0">
                {/* Tabs */}
                <div className="border-b border-gray-200 shrink-0">
                  <nav className="-mb-px flex overflow-x-scroll custom-scrollbar " aria-label="Tabs">
                    <button
                    type="button"
                      onClick={() => setActiveTab('personal')}
                      className={`${
                        activeTab === 'personal'
                          ? 'border-[#174540] text-[#174540]'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      } whitespace-nowrap py-4 px-6 border-t-2 font-medium text-sm`}
                    >
                      Informations Personnelles
                    </button>
                    <button
                    type="button"
                      onClick={() => setActiveTab('picture')}
                      className={`${
                        activeTab === 'picture'
                          ? 'border-[#174540] text-[#174540]'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      } whitespace-nowrap py-4 px-6 border-t-2 font-medium text-sm`}
                    >
                      Photo de Profil
                    </button>
                    <button
                    type="button"
                      onClick={() => setActiveTab('permissions')}
                      className={`${
                        activeTab === 'permissions'
                          ? 'border-[#174540] text-[#174540]'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      } whitespace-nowrap py-4 px-6 border-t-2 font-medium text-sm`}
                    >
                      Permissions
                    </button>
                    <button
                    type="button"
                      onClick={() => setActiveTab('assignations')}
                      className={`${
                        activeTab === 'assignations'
                          ? 'border-[#174540] text-[#174540]'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      } whitespace-nowrap py-4 px-6 border-t-2 font-medium text-sm`}
                    >
                      Dépôt & Produits
                    </button>
                  </nav>
                </div>

                {/* Tab content */}
                <div className="p-4 flex-1 min-h-0 overflow-y-auto">
                  <motion.div
                    key={activeTab}
                    initial="initial"
                    animate="animate"
                    variants={tabVariants}
                  >
                    {activeTab === 'personal' && (
                      <PersonalInfo
                        profileData={formData}
                        handleInputChange={handleChange}
                        errors={errors}
                        isSaving={isSubmitting}
                      />
                    )}

                    {activeTab === 'picture' && (
                      <ProfilePicture handleChange={handleChange}  initialData={initialData} localImage={formData.image}/>
                    )}

                    {activeTab === 'permissions' && (
                      <PermissionMenus
                      formData={formData}
                      onChangeInput={handleChange}
                    />
                    )}

                    {activeTab === 'assignations' && (
                      <div className="space-y-6">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Dépôt assigné</label>
                          <select
                            name="depotId"
                            value={formData.depotId || ''}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#174540]"
                          >
                            <option value="">-- Aucun (tous les dépôts) --</option>
                            {depots.map(d => (
                              <option key={d.id} value={d.id}>{d.name}{d.isDefault ? ' (par défaut)' : ''}</option>
                            ))}
                          </select>
                          <p className="text-xs text-gray-500 mt-1">L'utilisateur ne verra que le stock du dépôt sélectionné.</p>
                        </div>

                        <div>
                          <div className="flex items-center justify-between mb-2">
                            <label className="block text-sm font-medium text-gray-700">Produits assignés ({(formData.productIds||[]).length})</label>
                            <div className="flex gap-2">
                              <button type="button" className="text-xs text-[#174540] underline" onClick={() => setFormData(prev => ({ ...prev, productIds: allProducts.map(p => p.id) }))}>Tout sélectionner</button>
                              <button type="button" className="text-xs text-red-600 underline" onClick={() => setFormData(prev => ({ ...prev, productIds: [] }))}>Tout désélectionner</button>
                            </div>
                          </div>
                          <input
                            type="text"
                            placeholder="Rechercher un produit..."
                            value={productSearch}
                            onChange={(e) => setProductSearch(e.target.value)}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-2 focus:outline-none focus:ring-1 focus:ring-[#174540]"
                          />
                          <div className="max-h-[350px] overflow-y-auto border border-gray-200 rounded-md divide-y">
                            {allProducts
                              .filter(p => !productSearch || (p.name||'').toLowerCase().includes(productSearch.toLowerCase()) || (p.reference||'').toLowerCase().includes(productSearch.toLowerCase()))
                              .map(p => {
                                const checked = (formData.productIds||[]).includes(p.id);
                                return (
                                  <label key={p.id} className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={checked}
                                      onChange={(e) => {
                                        setFormData(prev => ({
                                          ...prev,
                                          productIds: e.target.checked
                                            ? [...(prev.productIds||[]), p.id]
                                            : (prev.productIds||[]).filter(id => id !== p.id)
                                        }));
                                      }}
                                      className="h-4 w-4 text-[#174540] rounded mr-3"
                                    />
                                    <div className="flex-1">
                                      <div className="text-sm text-gray-900">{p.name}</div>
                                      <div className="text-xs text-gray-500">{p.reference}</div>
                                    </div>
                                  </label>
                                );
                              })}
                            {allProducts.length === 0 && (
                              <div className="px-3 py-4 text-sm text-gray-500 text-center">Aucun produit trouvé.</div>
                            )}
                          </div>
                          <p className="text-xs text-gray-500 mt-1">Si aucun produit n'est sélectionné, l'utilisateur verra tous les produits.</p>
                        </div>
                      </div>
                    )}
                  </motion.div>


                  {errors.image && (
        <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">{errors.image}</p>
            </div>
          </div>
        </div>
      )}

                </div>
              </div>


    </form>
  );
};

export default AddUser;